import gql from 'graphql-tag';

import {
  AdmissionRoundFragment,
  AdmissionRoundExamRequiredDetailFragment,
} from './fragments/AdmissionRoundFragment';

export const tcasQuery = gql`
  query GetTcasSpec($tcasId: Int!) {
    admissionRound(id: $tcasId) {
      ...AdmissionRoundFragment
      ...AdmissionRoundExamRequiredDetailFragment
    }
  }
  ${AdmissionRoundFragment}
  ${AdmissionRoundExamRequiredDetailFragment}
`;
